import styled from 'styled-components'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type PageHeaderProps = {} & ClassNameProps & ChildrenProps

export const PageHeader = ({ className, children }: PageHeaderProps) => {
  return <Root className={className}>{children}</Root>
}

PageHeader.Title = styled.div`
  color: var(--text-12);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`

PageHeader.Description = styled.div`
  color: var(--text-11);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const Root = styled.div`
  min-height: 50px;
  background: var(--background-2);
  padding-inline: 10px;

  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
`
